import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { TODO } from '@/types'

const emptyCoordinatorQuestionnaire = (): TODO => ({
  inclusionReason: null,
  personalDifficulties: [],
  personalDifficultiesOther: null,
  activities: null,
  strength: null,
  previousEditions: null,
  numberOfEditions: null,
  programHelp: null,
  environmentalIssues: [],
  numberOfSiblings: null,
  sickFamilyMembers: null,
  familySchoolImpact: null,
  environmentalIssuesOther: null,
  incompleteFamily: [],
  incompleteFamilyOtherDescription: null,
  learningIssues: [],
  learningIssuesSpecificSchoolClass: null,
  peersIssues: [],
  peersIssuesOther: null,
  schoolCommitment: null,
  mentalEvaluation: null,
  mentalEvaluationDescription: null,
  schoolCoordinatorAdvice: null,
  attendPsychologicalOrPedagogicalTherapy: null,
  attendPsychologicalOrPedagogicalTherapyDescription: null,
  childBehaviorPreventSafeWork: null,
  childBehaviorPreventSafeWorkDescription: null,
  otherInformationAffectingSchoolFunctioning: null
})

export const useCoordinatorQuestionnaireStore = defineStore('coordinatorQuestionnaire', () => {
  const coordinatorQuestionnaire = ref(emptyCoordinatorQuestionnaire())

  const clearCoordinatorQuestionnaire = () => {
    coordinatorQuestionnaire.value = emptyCoordinatorQuestionnaire()
  }

  const setCoordinatorQuestionnaire = (fields: TODO) => {
    if (!fields) return
    coordinatorQuestionnaire.value = {
      ...coordinatorQuestionnaire.value,
      ...fields
    }
  }

  return {
    coordinatorQuestionnaire,
    clearCoordinatorQuestionnaire,
    setCoordinatorQuestionnaire
  }
})
